import React from "react";
import SelectorPopup from "../../components/SelectorPopup/SelectorPopup";


const ActivateAccountDialog = (props) => {
  const options = [
    {
      id: 18,
      title: 'page4 Light.Edition',
      text: <>Erklärung für Light.Edition. Erklärung für Light.Edition. Erklärung für Light.Edition.<br/><br/><b>5€ / Monat, 60€ pro Jahr</b></>
    },
    {
      id: 19,
      title: 'page4 Premium.Edition',
      text:  <>Erklärung für Light.Edition. Erklärung für Premium.Edition. Erklärung für Premium.Edition.<br/><br/><b>10€ / Monat, 120€ pro Jahr</b></>
    },
    {
      id: 20,
      title: "page4 Professional.Edition",
      text:  <>Erklärung für Light.Edition. Erklärung für Professional.Edition. Erklärung für Professional.Edition.<br/><br/><b>20€ / Monat, 240€ pro Jahr</b></>
    }
  ];
  return <SelectorPopup
    title={'Webseite aktivieren'}
    confirmButton={'Kostenpflichtig kaufen'}
    onConfirm={props.onClose}
    onCancel={() => props.onClose(false)}
    options={options}
  />
}

export default ActivateAccountDialog;